// @flow weak

import uuid from 'uuid';
import {FILE_UPLOAD, ABORT_UPLOAD} from '../middleware/fileUploader';
import {ADD as NOTIFICATION} from './notification';
import {GET, PUT, POST, DELETE} from '../helpers/request';

export const CUSTOM_ROW_GET_REQUEST = '@customRowView/CUSTOM_ROW_GET_REQUEST';
export const CUSTOM_ROW_GET_SUCCESS = '@customRowView/CUSTOM_ROW_GET_SUCCESS';
export const CUSTOM_ROW_GET_FAILURE = '@customRowView/CUSTOM_ROW_GET_FAILURE';

export const CUSTOM_ROW_UPDATE_REQUEST = '@customRowView/CUSTOM_ROW_UPDATE_REQUEST';
export const CUSTOM_ROW_UPDATE_SUCCESS = '@customRowView/CUSTOM_ROW_UPDATE_SUCCESS';
export const CUSTOM_ROW_UPDATE_FAILURE = '@customRowView/CUSTOM_ROW_UPDATE_FAILURE';

export const CUSTOM_ROW_CREATE_REQUEST = '@customRowView/CUSTOM_ROW_CREATE_REQUEST';
export const CUSTOM_ROW_CREATE_SUCCESS = '@customRowView/CUSTOM_ROW_CREATE_SUCCESS';
export const CUSTOM_ROW_CREATE_FAILURE = '@customRowView/CUSTOM_ROW_CREATE_FAILURE';

export const CUSTOM_ROW_REMOVE_REQUEST = '@customRowView/CUSTOM_ROW_REMOVE_REQUEST';
export const CUSTOM_ROW_REMOVE_SUCCESS = '@customRowView/CUSTOM_ROW_REMOVE_SUCCESS';
export const CUSTOM_ROW_REMOVE_FAILURE = '@customRowView/CUSTOM_ROW_REMOVE_FAILURE';

export const CUSTOM_ROW_DATA_GET_REQUEST = '@customRowView/CUSTOM_ROW_DATA_GET_REQUEST';
export const CUSTOM_ROW_DATA_GET_SUCCESS = '@customRowView/CUSTOM_ROW_DATA_GET_SUCCESS';
export const CUSTOM_ROW_DATA_GET_FAILURE = '@customRowView/CUSTOM_ROW_DATA_GET_FAILURE';

export const CUSTOM_ROW_ADD_FILE = '@customRowView/CUSTOM_ROW_ADD_FILE';
export const CUSTOM_ROW_REMOVE_FILE = '@customRowView/CUSTOM_ROW_REMOVE_FILE';
export const CUSTOM_ROW_UPLOAD_FILE = '@customRowView/CUSTOM_ROW_UPLOAD_FILE';
export const CUSTOM_ROW_ABORT_FILE_UPLOAD = '@customRowView/CUSTOM_ROW_ABORT_FILE_UPLOAD';

export const RESET = '@customRowView/RESET';
export const CLEAR = '@customRowView/CLEAR';

const customRowGetRequest = () => ({
  type: CUSTOM_ROW_GET_REQUEST,
});

const customRowGetSuccess = (row, order) => ({
  type: CUSTOM_ROW_GET_SUCCESS,
  row,
  order,
});

const customRowGetFailure = error => ({
  type: CUSTOM_ROW_GET_FAILURE,
  error,
});

const customRowUpdateRequest = () => ({
  type: CUSTOM_ROW_UPDATE_REQUEST,
});

const customRowUpdateSuccess = row => ({
  type: CUSTOM_ROW_UPDATE_SUCCESS,
  row,
  [NOTIFICATION]: {
    message: 'Friprodukt uppdaterad',
  },
});

const customRowUpdateFailure = error => ({
  type: CUSTOM_ROW_UPDATE_FAILURE,
  error,
});

const customRowCreateRequest = () => ({
  type: CUSTOM_ROW_CREATE_REQUEST,
});

const customRowCreateSuccess = (orderId, row) => ({
  type: CUSTOM_ROW_CREATE_SUCCESS,
  orderId,
  row,
  [NOTIFICATION]: {
    message: 'Friprodukt tillagd',
  },
});

const customRowCreateFailure = error => ({
  type: CUSTOM_ROW_CREATE_FAILURE,
  error,
});

const customRowRemoveRequest = () => ({
  type: CUSTOM_ROW_REMOVE_REQUEST,
});

const customRowRemoveSuccess = id => ({
  type: CUSTOM_ROW_REMOVE_SUCCESS,
  id,
  [NOTIFICATION]: {
    message: 'Friprodukt borttagen',
  },
});

const customRowRemoveFailure = error => ({
  type: CUSTOM_ROW_REMOVE_FAILURE,
  error,
});

const customRowDataGetRequest = () => ({
  type: CUSTOM_ROW_DATA_GET_REQUEST,
});

const customRowDataGetSuccess = (suppliers, productTypes, workerTypes, roomTypes, rooms) => ({
  type: CUSTOM_ROW_DATA_GET_SUCCESS,
  suppliers,
  productTypes,
  workerTypes,
  roomTypes,
  rooms,
});

const customRowDataGetFailure = error => ({
  type: CUSTOM_ROW_DATA_GET_FAILURE,
  error,
});

const customRowAddFile = name => (tempId, metadata) => ({
  type: CUSTOM_ROW_ADD_FILE,
  name,
  tempId,
  metadata,
});

export const customRowRemoveFile = name => ({
  type: CUSTOM_ROW_REMOVE_FILE,
  name,
});

export const customRowUploadFile = (name, file) => ({
  type: CUSTOM_ROW_UPLOAD_FILE,
  tempId: uuid.v4(),
  name,
  [FILE_UPLOAD]: {
    file,
    success: customRowAddFile(name),
  },
});

export const customRowAbortFileUpload = tempId => ({
  type: CUSTOM_ROW_ABORT_FILE_UPLOAD,
  tempId,
  [ABORT_UPLOAD]: true,
});

export const clear = () => ({
  type: CLEAR,
});

export const reset = () => ({
  type: RESET,
});

export const fetchCustomRow = (customRowId, orderId) => async dispatch => {
  dispatch(customRowGetRequest());
  try {
    const order = await GET({endpoint: `/orders/${orderId}`}, dispatch);
    const customRow = await GET({endpoint: `/customorderrows/${customRowId}`}, dispatch);
    dispatch(customRowGetSuccess(customRow, order));
  } catch (err) {
    dispatch(customRowGetFailure(err));
  }
};

export const fetchData = orderId => async dispatch => {
  dispatch(customRowDataGetRequest());
  try {
    const suppliers = await GET({endpoint: '/suppliers'}, dispatch);
    const productTypes = await GET({endpoint: '/producttypes'}, dispatch);
    const workerTypes = await GET({endpoint: '/workertypes'}, dispatch);
    const roomTypes = await GET({endpoint: '/roomtypes'}, dispatch);
    const rooms = await GET({endpoint: `/orders/${orderId}/rooms`}, dispatch);
    dispatch(customRowDataGetSuccess(suppliers, productTypes, workerTypes, roomTypes, rooms));
  } catch (err) {
    dispatch(customRowDataGetFailure(err));
  }
};

export const createCustomRow = (orderId, body) => async dispatch => {
  dispatch(customRowCreateRequest());
  try {
    const row = await POST({
      endpoint: `/orders/${orderId}/customrows`,
      body,
    }, dispatch);
    dispatch(customRowCreateSuccess(orderId, row));
  } catch (err) {
    dispatch(customRowCreateFailure(err));
  }
};

export const updateCustomRow = (id, body) => async dispatch => {
  dispatch(customRowUpdateRequest());
  try {
    const row = await PUT({
      endpoint: `/customorderrows/${id}`,
      body,
    }, dispatch);
    dispatch(customRowUpdateSuccess(row));
  } catch (err) {
    dispatch(customRowUpdateFailure(err));
  }
};

export const removeCustomRow = rowId => async dispatch => {
  dispatch(customRowRemoveRequest());
  try {
    await DELETE({
      endpoint: `/customorderrows/${rowId}`,
    }, dispatch);
    dispatch(customRowRemoveSuccess(rowId));
  } catch (err) {
    dispatch(customRowRemoveFailure(err));
  }
};



// WEBPACK FOOTER //
// ./src/actions/customRowView.js